import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, TextField } from '@mui/material';
import validator from 'validator';

import { authenticationAPIService } from '~/api/login';
import { qrcodeAPIService } from '~/api/qrcode';
import { RedWhiteAlert } from '~/components/atoms/RedWhiteAlert';
import AuthTemplate from '~/components/organisms/auth/AuthTemplate';
import { HTTP_STATUSE_CODES } from '~/constants/http-statuses-constants';
import { PATH } from '~/constants/route-path';
import { cookieService } from '~/services/cookie-service';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';
import { COLORS } from '~/styles/colors';

export default function FacebookEmail() {
  const { t } = useTranslation();

  const [email, setEmail] = useState('');
  const [isError, setIsError] = useState<boolean | string>(false);
  const [isEmailValid, setIsEmailValid] = useState(false);

  const [searchParams] = useSearchParams();
  const isAnonQr = searchParams.get('isAnonQr') || null;

  const qrCode = useSelector(getQrCodeReducerData);

  const navigate = useNavigate();

  const handleEmailValue = (e) => {
    const {
      target: { value },
    } = e;

    setEmail(value);
    setIsEmailValid(!validator.isEmail(value));

    if (!validator.isEmail(value)) {
      setIsError(false);
    }
  };

  const handleAddEmail = async () => {
    try {
      const resposne = await authenticationAPIService.updateAccount({ email });

      if (resposne?.status === HTTP_STATUSE_CODES.OK) {
        cookieService.deleteCookie('isFacebookLoginNotValid');

        if (isAnonQr) {
          await qrcodeAPIService.linkQrCodeToUser(qrCode?.data?.id, qrCode?.data);
        }

        navigate(PATH.QR.MAIN);
      }
    } catch (e) {
      setIsError(t('alerts:login'));
    }
  };

  return (
    <AuthTemplate
      customProps={{}}
      h1={t('login:createAccount')}
      h2={t('login:createTitle')}
      alertNode={<RedWhiteAlert isOpen={isError} text={isError} />}
      showPrivacyPolicyText
      bottomBody={
        <>
          <TextField
            helperText={isEmailValid && t('errors:emailIsValid')}
            error={isEmailValid}
            label={t('login:emailInput')}
            type="email"
            fullWidth
            onChange={handleEmailValue}
          />
          <Button
            fullWidth
            variant="cointained"
            onClick={handleAddEmail}
            disabled={isEmailValid}
            sx={{
              backgroundColor: COLORS.purple,
              color: COLORS.white,
              padding: '8 22px',
              mt: 1,
              '&:hover': {
                color: COLORS.black,
              },
              '&.Mui-disabled': {
                backgroundColor: COLORS.primaryGray,
              },
            }}
          >
            {t('checkout:continue')}
          </Button>
        </>
      }
    />
  );
}
